import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import {
  canDeleteRecords,
  canExportData,
} from "../../utilis/deleteExportPermissions";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import Loader from "../Loader/Loader";
import swal from "sweetalert";
import { get_ApiManager } from "../ApiManager/ApiManager";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { TaskCheckbox } from "../TaskManagement/DailyActivityLogger/DailyLogTaskRow";
import {
  buildWebsiteLeadsColumns,
  useLeadsColumnSettings,
  WEBSITE_LEADS_COLUMNS_STORAGE_KEY,
} from "./websiteLeadsColumnSettings";
import { LeadsColumnSettingsModal } from "./websiteLeadsModals";
import {
  LeadsCountBadge,
  LeadsDateRangeFilters,
  LeadsFilterCard,
  LeadsFilterField,
  LeadsFilterInput,
  LeadsFilterSelect,
  LEADS_FILTER_ICONS,
  LeadsGhostButton,
  LeadsPageHeader,
  LeadsPageShell,
  LeadsPagination,
  LeadsPrimaryButton,
  LeadsSelectionBar,
  LeadsSuccessButton,
  LeadsTableCard,
  LeadsTableToolbar,
  LeadsTableWrap,
  LeadsAssignedBadge,
  LeadsFormTypeBadge,
  LeadsMovedIcon,
  LeadsRowIconButton,
  LeadsTruncatedText,
  formatFormType,
  formatLeadDate,
  getLeadsTableColClass,
  leadsSelectClass,
} from "./websiteLeadsShared";
function WebsiteLeads() {
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [branchs, setBranches] = useState(null);
  const [types, setTypes] = useState(null);
  const [sortColumn, setSortColumn] = useState(null);
  const [order, setOrder] = useState("ASC");
  const [showColumnSettings, setShowColumnSettings] = useState(false);

  const [items, setItems] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const canAssign = permissions["assign_website_leads"] === 1;
  const allColumns = useMemo(
    () => buildWebsiteLeadsColumns(canAssign),
    [canAssign],
  );
  const {
    visibility,
    visibleColumns,
    hideableColumns,
    toggleColumn,
    resetToDefaults,
  } = useLeadsColumnSettings(WEBSITE_LEADS_COLUMNS_STORAGE_KEY, allColumns);

  // states for website registeration
  const [filters, setFilters] = useState({
    name: "",
    email: "",
    contact: "",
    form_type: "",
    country: "",
    destination: "",
    nearest_office: "",
    assigned_user_id: "",
    start_date: "",
    end_date: "",
    sort_by: "",
    sort_dir: "asc",
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectAll(false);
      setSelectedRows([]);
      return;
    }
    setSelectAll(true);
    setSelectedRows(items.map((item) => item.id));
  };

  const handleRowSelect = (leadId) => {
    setSelectedRows((prev) => {
      if (prev.includes(leadId)) {
        const newSelected = prev.filter((id) => id !== leadId);
        setSelectAll(newSelected.length === items.length);
        return newSelected;
      }
      const newSelected = [...prev, leadId];
      setSelectAll(newSelected.length === items.length);
      return newSelected;
    });
  };

  const getAllUsers = async () => {
    try {
      const response = await apiUrl.get("fetchAllActiveUsers");
      if (response?.data?.data) {
        setAllUsers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleAssignUser = async (e) => {
    if (selectedRows.length === 0) {
      swal("Warning!", "Please select at least one lead to assign.", "warning");
      return;
    }
    const userId = e.target.value;
    const assignUser = allUsers.find((user) => String(user.id) === String(userId));
    setSelectedUser(userId);

    const confirmAssign = await swal({
      title: "Are you sure?",
      text: `Assign ${selectedRows.length} selected lead(s) to ${assignUser?.name}?`,
      icon: "warning",
      buttons: true,
    });

    if (confirmAssign) {
      try {
        setLoading(true);
        const response = await apiUrl.post("assignWebsiteLeadsToUser", {
          lead_ids: selectedRows,
          user_id: userId,
        });

        if (response?.data?.status) {
          swal(
            "Assigned!",
            `${selectedRows.length} lead(s) assigned successfully.`,
            "success",
          );
          setSelectedRows([]);
          setSelectAll(false);
          setSelectedUser(null);
          fetchWebsiteRegistrationsData();
        } else {
          swal(
            "Failed!",
            response?.data?.message || "Something went wrong.",
            "error",
          );
        }
      } catch (error) {
        swal("Error!", "Something went wrong while assigning leads.", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  const getAssignedUserName = (assignedUserId) => {
    if (!assignedUserId) return "—";
    const user = allUsers.find((u) => u.id === assignedUserId);
    return user?.name || "—";
  };

  // Remove debouncing - filters don't auto-search
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // request for sorting
  const sorting = (col) => {
    const sorted = [...items].sort((a, b) => {
      const valA = a[col]?.toString().toLowerCase();
      const valB = b[col]?.toString().toLowerCase();
      if (order === "ASC") {
        return valA > valB ? 1 : -1;
      } else {
        return valA < valB ? 1 : -1;
      }
    });

    setItems(sorted);
    setOrder(order === "ASC" ? "DESC" : "ASC");
    setSortColumn(col);
  };

  // when component load it first fetch the permission
  useEffect(() => {
    const perms = getPermissions();
    if (perms) {
      setPermissions(perms);
      if (perms["assign_website_leads"] === 1) {
        getAllUsers();
      }
    }
  }, []);

  //   call only once for setting the branches
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        setLoading(true);
        const resp = await apiUrl.get("get_branches_type");
        if (resp) {
          const { branches: branchesData, types: typesData } = resp.data.data;
          setTypes(typesData);
          setBranches(branchesData);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchBranches();
  }, []);

  // Fetch website Registration Records
  const fetchWebsiteRegistrationsData = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        perPage: pagination.perPage,
        page: pagination.currentPage,
        ...filters,
      };
      const resp = await apiUrl.get("website_registrations", { params });
      if (resp) {
        const { items: dataItems, meta: dataMeta } = resp.data.data;
        setItems(dataItems);
        setPagination((prev) => ({
          ...prev,
          total: dataMeta.total,
          lastPage: dataMeta.last_page,
        }));
        return { dataItems };
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [filters, pagination.currentPage, pagination.perPage]);

  // fetch the website registration data only when search is triggered or pagination changes
  useEffect(() => {
    if (pagination.currentPage > 0) {
      fetchWebsiteRegistrationsData();
    }
  }, [pagination.currentPage, pagination.perPage, fetchWebsiteRegistrationsData]);

  //  handle to change the branch - works independently
  const handleBranchChange = async (selectedBranch) => {
    setFilters((prev) => ({
      ...prev,
      nearest_office: selectedBranch,
    }));
    // Branch change triggers immediate search
    setPagination((prev) => ({ ...prev, currentPage: 1 }));

    // Immediately fetch data with new branch filter
    setLoading(true);
    try {
      const params = {
        perPage: pagination.perPage,
        page: 1,
        ...filters,
        nearest_office: selectedBranch,
      };
      const resp = await apiUrl.get("website_registrations", { params });
      if (resp) {
        const { items: dataItems, meta: dataMeta } = resp.data.data;
        setItems(dataItems);
        setPagination((prev) => ({
          ...prev,
          total: dataMeta.total,
          lastPage: dataMeta.last_page,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Clear all filters
  const clearAllFilters = async () => {
    // Clear only filters, keep branch selection
    const currentBranch = filters.nearest_office;
    setFilters({
      name: "",
      email: "",
      contact: "",
      form_type: "",
      country: "",
      destination: "",
      nearest_office: currentBranch,
      assigned_user_id: "",
      start_date: "",
      end_date: "",
    });

    // Reset to page 1 and fetch data with cleared filters
    setPagination((prev) => ({ ...prev, currentPage: 1 }));

    // Immediately fetch data with cleared filters
    setLoading(true);
    try {
      const params = {
        perPage: pagination.perPage,
        page: 1,
        name: "",
        email: "",
        contact: "",
        form_type: "",
        country: "",
        destination: "",
        nearest_office: currentBranch,
        assigned_user_id: "",
        start_date: "",
        end_date: "",
      };
      const resp = await apiUrl.get("website_registrations", { params });
      if (resp) {
        const { items: dataItems, meta: dataMeta } = resp.data.data;
        setItems(dataItems);
        setPagination((prev) => ({
          ...prev,
          total: dataMeta.total,
          lastPage: dataMeta.last_page,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Search button handler
  const handleSearch = async () => {
    setPagination((prev) => ({ ...prev, currentPage: 1 }));

    // Immediately fetch data with current filters
    setLoading(true);
    try {
      const params = {
        perPage: pagination.perPage,
        page: 1,
        ...filters,
      };
      const resp = await apiUrl.get("website_registrations", { params });
      if (resp) {
        const { items: dataItems, meta: dataMeta } = resp.data.data;
        setItems(dataItems);
        setPagination((prev) => ({
          ...prev,
          total: dataMeta.total,
          lastPage: dataMeta.last_page,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // handle page change from ReactPaginate
  const handlePageChange = (selectedItem) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selectedItem.selected + 1,
    }));
  };

  // handle per page change
  const handlePerPageChange = (e) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(e.target.value),
      currentPage: 1,
    }));
  };

  // delete a user
  const deleteUser = async (delete_id, name) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: `You will not be able to recover (${name})`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const url = "deleteWebsiteUser";
        const data = delete_id;
        const res = await get_ApiManager(data, url);
        console.log("User Deleted", res);
        swal(`User (${name}) unregistered Successfully!`, {
          icon: "success",
        });
        // Fetch latest data after delete
        const params = {
          perPage: pagination.perPage,
          page: pagination.currentPage,
          ...filters,
        };
        setLoading(true);
        const resp = await apiUrl.get("website_registrations", { params });
        if (resp) {
          const { items: dataItems, meta: dataMeta } = resp.data.data;
          setItems(dataItems);
          setPagination((prev) => ({
            ...prev,
            total: dataMeta.total,
            lastPage: dataMeta.last_page,
          }));
        }
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    }
  };

  // move to client
  const moveWebsiteLeads = async (id) => {
    if (id) {
      let url = `moveWebsiteLeads`;
      get_ApiManager(
        id,
        url,
        (res) => {
          console.log("move-website", res);
          // Fetch latest data after move
          fetchWebsiteRegistrationsData();
        },
        (err) => {
          console.log(err);
        }
      );
    }
  };
  // Function to export current items as Excel
  const handleExportToExcel = async () => {
    const params = {
      ...filters,
      perPage: pagination?.total,
      page: 1,
    };
    try {
      const res = await apiUrl.get("website_registrations", { params });
      const dataItems = res?.data?.data?.items;

      if (!dataItems || dataItems.length === 0) {
        swal("No data to export", "", "info");
        return;
      }
      const filteredData = dataItems.map((item) => {
        const { id, moved, resume_path, index, ...filteredItem } = item;
        return filteredItem;
      });
      const worksheet = XLSX.utils.json_to_sheet(filteredData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Website Leads");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });

      FileSaver.saveAs(data, "Website_Leads.xlsx");
    } catch (error) {
      console.error("Export failed:", error);
      swal("Failed to export data", "", "error");
    }
  };

  const renderCell = (column, item, context = {}) => {
    const { assignedName, isSelected } = context;

    switch (column.key) {
      case "select":
        return (
          <TaskCheckbox
            checked={isSelected}
            onClick={() => handleRowSelect(item.id)}
            title={`Select ${item.name}`}
          />
        );
      case "id":
        return item.id;
      case "name":
        return (
          <span className="fw-semibold text-dark" title={item.name}>
            {item.name}
          </span>
        );
      case "email":
        return item.email;
      case "phone":
        return item.phone;
      case "country":
        return item.country;
      case "destination":
        return item.destination;
      case "inquiry":
        return <LeadsTruncatedText text={item.inquiry} />;
      case "type":
        return <LeadsFormTypeBadge type={item.type} />;
      case "assigned_user_id":
        return <LeadsAssignedBadge name={assignedName} />;
      case "created_at":
        return formatLeadDate(item.created_at);
      case "actions":
        return (
          <div className="d-flex align-items-center gap-1">
            {canDeleteRecords(permissions) && (
              <LeadsRowIconButton
                icon={FaIcons.FaTrash}
                onClick={() => deleteUser(item.id, item.name)}
                title="Delete lead"
                variant="danger"
              />
            )}
            {item.moved === 1 ? (
              <LeadsMovedIcon />
            ) : (
              <LeadsRowIconButton
                icon={FaIcons.FaUserPlus}
                onClick={() => moveWebsiteLeads(item.id)}
                title="Move to client"
                variant="primary"
              />
            )}
          </div>
        );
      default:
        return item[column.key] ?? "—";
    }
  };

  return (
    <LeadsPageShell>
        <LeadsPageHeader
          icon={FaIcons.FaGlobe}
          title="Website Leads"
          subtitle="Manage, assign, and convert inbound website registrations"
          actions={
            permissions?.floor_manager === 1 ? (
              <select
                id="branch"
                className={leadsSelectClass}
                style={{ minWidth: 150 }}
                value={filters.nearest_office}
                onChange={(e) => handleBranchChange(e.target.value)}
                aria-label="Branch"
              >
                <option value="">All Branches</option>
                {branchs?.map((branch, idx) => (
                  <option key={idx} value={branch}>
                    {branch.charAt(0).toUpperCase() + branch.slice(1)}
                  </option>
                ))}
              </select>
            ) : null
          }
        />

        <LeadsFilterCard
          headerRight={<LeadsCountBadge count={pagination.total} />}
          actions={
            <>
              <LeadsGhostButton onClick={clearAllFilters}>Clear</LeadsGhostButton>
              <LeadsPrimaryButton onClick={handleSearch}>
                <FaIcons.FaSearch size={11} /> Search
              </LeadsPrimaryButton>
              {canExportData(permissions) && (
                <LeadsSuccessButton onClick={handleExportToExcel} disabled={loading}>
                  <FaIcons.FaFileExcel size={11} /> Export
                </LeadsSuccessButton>
              )}
            </>
          }
        >
          <LeadsFilterField label="Name" id="name">
            <LeadsFilterInput
              id="name"
              icon={LEADS_FILTER_ICONS.name}
              placeholder="Search name"
              value={filters.name}
              onChange={(e) => handleFilterChange("name", e.target.value)}
            />
          </LeadsFilterField>
          <LeadsFilterField label="Email" id="email">
            <LeadsFilterInput
              id="email"
              type="email"
              icon={LEADS_FILTER_ICONS.email}
              placeholder="Search email"
              value={filters.email}
              onChange={(e) => handleFilterChange("email", e.target.value)}
            />
          </LeadsFilterField>
          <LeadsFilterField label="Contact" id="contact">
            <LeadsFilterInput
              id="contact"
              icon={LEADS_FILTER_ICONS.phone}
              placeholder="Phone number"
              value={filters.contact}
              onChange={(e) => handleFilterChange("contact", e.target.value)}
            />
          </LeadsFilterField>
          <LeadsFilterField label="Origin Country" id="country">
            <LeadsFilterInput
              id="country"
              icon={LEADS_FILTER_ICONS.country}
              placeholder="Country"
              value={filters.country}
              onChange={(e) => handleFilterChange("country", e.target.value)}
            />
          </LeadsFilterField>
          <LeadsFilterField label="Destination" id="destination">
            <LeadsFilterInput
              id="destination"
              icon={LEADS_FILTER_ICONS.destination}
              placeholder="Destination"
              value={filters.destination}
              onChange={(e) =>
                handleFilterChange("destination", e.target.value)
              }
            />
          </LeadsFilterField>
          <LeadsFilterField label="Form Type" id="form_type">
            <LeadsFilterSelect
              id="form_type"
              icon={LEADS_FILTER_ICONS.form_type}
              value={filters.form_type}
              onChange={(e) => handleFilterChange("form_type", e.target.value)}
              ariaLabel="Form type"
            >
              <option value="">All types</option>
              {types?.map((type, idx) => (
                <option key={idx} value={type}>
                  {formatFormType(type)}
                </option>
              ))}
            </LeadsFilterSelect>
          </LeadsFilterField>
          {canAssign && (
            <LeadsFilterField label="Assigned To" id="assigned_user_id">
              <LeadsFilterSelect
                id="assigned_user_id"
                icon={LEADS_FILTER_ICONS.assigned_user_id}
                value={filters.assigned_user_id}
                onChange={(e) =>
                  handleFilterChange("assigned_user_id", e.target.value)
                }
                ariaLabel="Assigned to"
              >
                <option value="">Anyone</option>
                {allUsers.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user?.name}
                  </option>
                ))}
              </LeadsFilterSelect>
            </LeadsFilterField>
          )}
          <LeadsDateRangeFilters
            startId="start_date"
            endId="end_date"
            startValue={filters.start_date}
            endValue={filters.end_date}
            onChange={handleFilterChange}
          />
        </LeadsFilterCard>

        <LeadsTableCard
          loading={loading}
          loader={<Loader />}
          toolbar={
            <LeadsTableToolbar
              title="All Website Leads"
              onSettingsClick={() => setShowColumnSettings(true)}
              right={
                canAssign && selectedRows.length > 0 ? (
                  <LeadsSelectionBar count={selectedRows.length}>
                    <select
                      className={leadsSelectClass}
                      name="assigned_user_id"
                      value={selectedUser || ""}
                      onChange={handleAssignUser}
                      aria-label="Assign selected leads to user"
                    >
                      <option value="">Assign to user…</option>
                      {allUsers.map((user) => (
                        <option key={user.id} value={user.id.toString()}>
                          {user?.name}
                        </option>
                      ))}
                    </select>
                  </LeadsSelectionBar>
                ) : null
              }
            />
          }
        >
          <LeadsTableWrap>
            <table className="website-leads-table">
              <thead>
                <tr>
                  {visibleColumns.map((header) => (
                    <th
                      key={header.key}
                      className={getLeadsTableColClass(header.key)}
                      onClick={() => header.dataKey && sorting(header.dataKey)}
                      style={header.dataKey ? { cursor: "pointer" } : undefined}
                    >
                      {header.key === "select" ? (
                        <TaskCheckbox
                          checked={selectAll}
                          onClick={handleSelectAll}
                          title="Select all"
                        />
                      ) : (
                        <>
                          {header.title}
                          {sortColumn === header.dataKey && (
                            <span>{order === "ASC" ? " ▲" : " ▼"}</span>
                          )}
                        </>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items?.length > 0 ? (
                  items.map((item) => {
                    const assignedName =
                      item.assigned_user?.name ||
                      getAssignedUserName(item.assigned_user_id);
                    const isSelected = selectedRows.includes(item.id);

                    return (
                      <tr
                        key={item.id}
                        className={isSelected ? "website-leads-row--selected" : ""}
                      >
                        {visibleColumns.map((column) => (
                          <td
                            key={`${item.id}-${column.key}`}
                            className={getLeadsTableColClass(column.key)}
                            title={
                              ["email", "phone", "country", "destination", "name"].includes(
                                column.key,
                              )
                                ? item[column.key] || undefined
                                : undefined
                            }
                          >
                            {renderCell(column, item, { assignedName, isSelected })}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={visibleColumns.length}
                      className="text-center text-muted"
                      style={{ padding: "2rem 0.5rem", fontSize: 11 }}
                    >
                      No leads found. Try adjusting your filters.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </LeadsTableWrap>
        </LeadsTableCard>

        <LeadsPagination
          pagination={pagination}
          onPageChange={handlePageChange}
          onPerPageChange={handlePerPageChange}
        />

        <LeadsColumnSettingsModal
          show={showColumnSettings}
          onClose={() => setShowColumnSettings(false)}
          columns={hideableColumns}
          visibility={visibility}
          onToggle={toggleColumn}
          onReset={resetToDefaults}
        />
    </LeadsPageShell>
  );
}

export default WebsiteLeads;
